<template>
    <CIcon
        v-if="stateAppLayout.collapsed"
        file="toggle-sidebar-left.svg"
        class="text-20"
        @click="() => onCollapsed(!stateAppLayout.collapsed)"
    ></CIcon>
    <CIcon v-else class="text-20" file="toggle-sidebar-right.svg" @click="() => onCollapsed(!stateAppLayout.collapsed)"></CIcon>
    <Tag color="blue" class="ml-2 text-14" v-if="profile && profile !== 'prod'">{{ profile }}</Tag>
</template>

<script>
import { Tag } from "ant-design-vue";
import { defineAsyncComponent, defineComponent } from "vue";
import { onCollapsed, state as stateAppLayout } from "./app-layout.logic";

export default defineComponent({
    components: {
        CIcon: defineAsyncComponent(() => import("../../icon/CIcon")),
        Tag
    },
    setup() {
        return { stateAppLayout, onCollapsed, profile: process.env.VUE_APP_PROFILE };
    }
});
</script>
